export default __webpack_public_path__ + "static/media/1473.4db47e2a.png";